import React from 'react'
import './Matchup.css';
import ModeSelector from '../ModeSelector/ModeSelector';
import OpponentSelector from '../OpponentSelector/OpponentSelector';
import Fighter from '../Fighter/Fighter';

class Matchup extends React.Component {

  render() {
    return (
      <div className="matchupAnchor">
        <div className="matchupAnchor2">
          <div className="matchup">
            <Fighter image={this.props.selected.image} playMetric={1} maxMetric={1}/>
            <div className="vsFlairContainer">
              <div className="vsFlair">Vs</div>
            </div>
            <Fighter image={this.props.opponent.image} playMetric={1} maxMetric={1}/>
            <ModeSelector selectMode={this.props.selectMode} />
            <button onClick={this.props.randomizer}>Randomize!</button>
            <OpponentSelector roster={this.props.roster} selectOpponent={this.props.selectOpponent}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Matchup;



// WEBPACK FOOTER //
// ./src/Components/Matchup/Matchup.js